import { useEffect, useState } from 'react'
import useRNWebViewTranslation from '@/hooks/useRNWebViewTranslation'

type DeviceType = 'iOS' | 'Android' | 'Other'
type AppType = 'app_ios' | 'app_android' | 'app_web'

const useDeviceDetector = (): { device: DeviceType; appType: string } => {
  const [device, setDevice] = useState<DeviceType>('Other')
  const [appType, setAppType] = useState<AppType>('app_web')
  const hasRNWebView = useRNWebViewTranslation()

  useEffect(() => {
    if (typeof window !== 'undefined') {
      const ua = navigator.userAgent || navigator.vendor || (window as any).opera

      // Detect iOS devices (iPadOS 13+ reports a desktop Mac user agent, only touch support tells them apart)
      const isIPadOS = /Macintosh/.test(ua) && navigator.maxTouchPoints > 1
      if ((/iPad|iPhone|iPod/.test(ua) || isIPadOS) && !(window as any).MSStream) {
        setDevice('iOS')
      }
      // Detect Android devices
      else if (/android/i.test(ua)) {
        setDevice('Android')
      } else {
        setDevice('Other')
      }
    }
  }, [])

  useEffect(() => {
    setAppType(
      device === 'iOS' && hasRNWebView ? 'app_ios' : device === 'Android' && hasRNWebView ? 'app_android' : 'app_web',
    )
  }, [device, hasRNWebView])

  return { device, appType }
}

export default useDeviceDetector
